import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Styles from './Notifications.module.scss';
export function Notifications() {
    const events = useSortedNotifications();
    if (events.length === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", { style: { height: '25vh', marginBottom: 'var(--gap-main)', fontSize: '0.8em', position: 'relative' }, children: _jsxs(Components.Frame, { children: [_jsx(Components.FrameComponent, { side: Components.FrameComponentType.Top, type: Components.FrameSideType.Big }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Bottom, type: Components.FrameSideType.Big }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Content, children: _jsx("div", { className: Styles.notifications, children: events.map(ev => _jsx(Notification, { Name: ev.Code, Path: ev.Path, Created: ev.Timestamp, Parameters: ev.Params }, ev.key)) }) })] }) }));
}
export function Notification(props) {
    function formatParemeters(value) {
        if (value === null) {
            return 'null';
        }
        if (value === true) {
            return 'true';
        }
        if (value === false) {
            return 'false';
        }
        return value;
    }
    return (_jsxs("div", { className: Styles.notification, children: [_jsx("span", { className: Styles.timestamp, children: props.Created }), _jsxs("p", { className: Styles.title, children: [props.Name, " - ", _jsx("small", { children: props.Path })] }), _jsx("div", { className: Styles.parameters, children: Object.keys(props.Parameters || {}).map(key => (_jsx(Components.Property, { title: key, children: formatParemeters(props.Parameters[key]) }, key))) })] }));
}
export function useSortedNotifications() {
    const context = Common.useSpaContext();
    const events = context?.events || {};
    const list = {};
    for (const service in events) {
        const event = Object.keys(events[service] || {});
        for (const key of event) {
            const item = JSON.parse(events[service][key]);
            if (item) {
                item.key = key;
                list[key] = item;
            }
        }
    }
    return Object.keys(list).sort().reverse().map((key) => {
        return list[key];
    });
}
